import { SeasonThreeUserByWalletResponse } from '../../types/rewards';

export const getSeasonThreeUserByWalletModel = (response: SeasonThreeUserByWalletResponse): SeasonThreeUserByWalletResponse => response;
